import { applyKmMask } from '../utils/applyMasks'

const elContainer = document.querySelector('.sales__used-evaluation-container')

if (elContainer) {
	applyKmMask(elContainer)
}